<template>
  <div :class="['productList', { inApp: $root.$data.isApp }]" >
    <common-title titleName="套餐课程列表" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <div class="content">
        <ul class="courseList">
          <CombinationCard v-for="(item, keys) in courseList" :key="keys" :item="item" />
        </ul>
        <!-- loading -->
        <Loading ref="load" v-if="!courseList.length" />
        <EmptyData :emptyName="'noProductList'" v-if="listEmpty" />
        <Foot/>
    </div>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Foot from '@/components/foot/privacy.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
// eslint-disable-next-line import/no-cycle
import { reqCombinationlist } from '@/api/combination';
import { loadMantisChat } from '@/utils/tools';
import { mapState } from 'vuex';
import Loading from '../../components/loading/loading.vue';


export default {
  components: {
    CommonTitle,
    CombinationCard,
    EmptyData,
    Loading,
    Foot,
  },
  data() {
    return {
      courseList: [], // 课程列表
      loading: false,
      listEmpty: false, // 在loading时不显示缺省页
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  created() {
    this.$nextTick(() => {
      this.$refs.load.show = true;
    });
    this.getCombinationlist();
  },
  mounted() {
    loadMantisChat(this.userInfo);
  },
  methods: {
    async getCombinationlist() {
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const { packageIds } = this.$route.query;
      const allPackageIds = packageIds.split(',');
      const res = allPackageIds.length ? await reqCombinationlist(0, endPoint, allPackageIds) : {};
      if (res?.code === 0 && res?.data?.length) {
        this.courseList = this.resetCoursePackage(res.data || []);
      } else {
        this.$refs.load.show = !this.courseList.length;
        this.listEmpty = true;
      }
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount
          && item.sellPrice > 0
          && !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },

  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-pull-refresh {
  height: 100%;
  overflow: inherit;
}
.productList {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 100px 36px 0 36px;
  background: #fefeff;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
  .content {
    height: 100%;
  }
  .courseList {
    box-sizing: border-box;
    width: 100%;
    min-height: 98px;
    padding: 20px 0;
    background: #fff;
  }

  .courseList > li {
    position: relative;
    width: 686px;
    // height: 3.06px;
    // border: 1px solid red;
    // display: flex;
    // flex-wrap: nowrap;
    margin: 0 auto;
    margin-bottom: 25px;
    padding: 0.32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(240, 244, 244, 1);
    opacity: 1;
    .liveImg {
      position: absolute;
      top: 0;
      right: 0;
      width: 140px;
      height: 50px;
      border-radius: 0 16px 0 32px;
    }
  }
}
</style>
